export default {
  BASE_URL: 'https://api.pushshift.io/reddit/',
  REDDIT_USER: 'https://www.reddit.com/user/',
  days: [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ],
  hours: [
    '12:00am',
    '2:00am',
    '4:00am',
    '6:00am',
    '8:00am',
    '10:00am',
    '12:00pm',
    '2:00pm',
    '4:00pm',
    '6:00pm',
    '8:00pm',
    '10:00pm',
  ],
};
